module.exports = [{"type":"title","text":"2025-11-25"},{"type":"normal","text":"規範入參與出參，統一為BTC-USDT。","style":{"font-weight":"bold"},"children":[{"type":"html","text":"現貨交易: 將現貨最新成交價行情接口由 v1 升級為 v2。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-11-25.json
// module id = h/Yp
// module chunks = 3